import { render, staticRenderFns } from "./AddFarmer.vue?vue&type=template&id=de418c32&"
import script from "./AddFarmer.vue?vue&type=script&lang=js&"
export * from "./AddFarmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports